export const nav = {
  home: "Accueil",
  howItWorks: "Comment ça marche",
  discover: "Découvrir",
  explore: "Explorer",
  exploreDesc: "Découvrez les membres et destinations",
  destinations: "Destinations",
  destinationsDesc: "Parcourez les destinations disponibles",
  membersMap: "Carte des membres",
  membersMapDesc: "Trouvez des membres près de chez vous",
  pricing: "Tarifs",
  dashboard: "Tableau de bord",
  dashboardDesc: "Gérez vos annonces et échanges",
  mySpace: "Mon espace",
  myCalendar: "Mon agenda",
  myCalendarDesc: "Gérez votre calendrier et vos échanges",
  incomingRequests: "Matching intelligent",
  incomingRequestsDesc: "Demandes reçues et suggestions IA",
  favorites: "Favoris",
  favoritesDesc: "Vos destinations favorites",
  messaging: "Messagerie",
  messagingDesc: "Conversations et propositions",
  login: "Connexion",
  signup: "Inscription",
  corporate: "Entreprise",
  announcement:
    "DONKEY TRAVEL — Le club européen d'échange de maisons réservé aux hôtes Airbnb notés 4,5 et plus",
};
